console.log('[AB Upsell] JS file loaded');

(function () {
  'use strict';

  var STORAGE_KEY = 'ab_customer_behavior_v1';
  var MAX_ITEMS_TO_SHOW = 10;

var PRIORITY_KEYWORD_RULES = [
  /*
    DOG - Hampers / gift boxes
  */
  {
    keywords: [
      'dog hamper', 'dog hampers', 'dog gift', 'dog gifts', 'dog gift box',
      'dog basket', 'dog birthday gift', 'gift for dog', 'gift for dogs',
      'present for dog', 'present for dogs', 'woof', 'pooch', 'pup gift'
    ],
    collection: 'dog-hampers'
  },

  /*
    CAT - Hampers / gift boxes
  */
  {
    keywords: [
      'cat hamper', 'cat hampers', 'cat gift', 'cat gifts', 'cat gift box',
      'gift for cat', 'gift for cats', 'kitty gift', 'kitten gift',
      'purr', 'purrfect', 'feline gift'
    ],
    collection: 'cat-hampers'
  },

  /*
    General pet hampers / gift boxes
  */
  {
    keywords: [
      'pet hamper', 'pet hampers', 'pet gift', 'pet gifts', 'pet gift box',
      'gift box', 'gift boxes', 'hamper', 'hampers', 'bundle gift',
      'furry friend gift', 'furball gift'
    ],
    collection: 'pet-hampers'
  },

  /*
    Dog treats
  */
  {
    keywords: [
      'dog treat', 'dog treats', 'treats for dog', 'training treat',
      'training treats', 'reward', 'rewards', 'snack', 'snacks',
      'chew', 'chews', 'bully stick', 'bully sticks', 'roo', 'kangaroo',
      'beef liver', 'yoghurt drops', 'chicken skewers', 'pork twists',
      'blackdog', 'black dog', 'wag', 'greenies', 'savourlife',
      'healthy treats', 'natural treats', 'grain free'
    ],
    collection: 'dog-treats'
  },

  /*
    Long-lasting / occupier treats
  */
  {
    keywords: [
      'occupier', 'occupier treat', 'occupier treats', 'long lasting',
      'keep dog busy', 'keep dogs busy', 'busy dog', 'bored dog',
      'boredom', 'power chewer', 'chewer', 'chewing', 'mental stimulation',
      'enrichment treat', 'lickimat', 'lick mat'
    ],
    collection: 'dog-occupier-treats'
  },

  /*
    Dog toys
  */
  {
    keywords: [
      'dog toy', 'dog toys', 'toy for dog', 'toys for dog',
      'chew toy', 'chew toys', 'fetch', 'ball', 'balls',
      'tug', 'rope', 'squeaky', 'squeaker', 'plush toy',
      'durable toy', 'tough toy', 'interactive toy', 'enrichment toy',
      'kong', 'zippypaws', 'west paw', 'doog', 'fringe studio',
      'play', 'playing'
    ],
    collection: 'dog-toys'
  },

  /*
    Puppy products / puppy packs
  */
  {
    keywords: [
      'puppy', 'puppies', 'new puppy', 'puppy pack', 'puppy packs',
      'puppy hamper', 'puppy gift', 'puppy toy', 'puppy toys',
      'puppy treat', 'puppy treats', 'young dog', 'small puppy',
      'kit for puppy', 'starter pack'
    ],
    collection: 'new-puppy-packs'
  },

  /*
    Dog birthday
  */
  {
    keywords: [
      'dog birthday', 'birthday dog', 'dog birthday box',
      'birthday box for dog', 'birthday hamper', 'party time',
      'party hamper', 'birthday kit', 'happy birthday dog',
      'birthday gift for dog'
    ],
    collection: 'dog-birthday-box'
  },

  /*
    Cat birthday
  */
  {
    keywords: [
      'cat birthday', 'birthday cat', 'cat birthday hamper',
      'birthday hamper for cat', 'birthday gift for cat',
      'happy birthday cat', 'kitty birthday'
    ],
    collection: 'cat-birthday-hampers'
  },

  /*
    Cat toys
  */
  {
    keywords: [
      'cat toy', 'cat toys', 'toy for cat', 'toys for cat',
      'catnip', 'cat nip', 'catnip spray', 'wand', 'feather',
      'chase', 'pounce', 'interactive cat toy', 'sensory toy',
      'plush cat toy', 'yeowww', 'kong cat', 'scratch', 'scratcher'
    ],
    collection: 'cat-toys'
  },

  /*
    Cat treats
  */
  {
    keywords: [
      'cat treat', 'cat treats', 'treats for cat',
      'kitty treat', 'kitten treat', 'feline treat',
      'kiwi kitchens', 'lamb cat treats', 'cat snack',
      'natural cat treats'
    ],
    collection: 'cyo-cat-treats'
  },

  /*
    Dog accessories
  */
  {
    keywords: [
      'dog accessory', 'dog accessories', 'collar', 'collars',
      'lead', 'leash', 'harness', 'bowl', 'bowls',
      'travel', 'seat', 'dog door', 'poo bag', 'poo bags',
      'training lead', 'pet corrector', 'halti', 'grooming accessory'
    ],
    collection: 'dog-accessories'
  },

  /*
    Dog grooming / pamper
  */
  {
    keywords: [
      'grooming', 'dog grooming', 'grooming kit', 'dog grooming kit',
      'pamper', 'pamper hamper', 'dog pamper', 'brush',
      'towel', 'spa', 'coat', 'clean', 'wash'
    ],
    collection: 'dog-grooming-pamper-hampers'
  },

  /*
    Dog food
  */
  {
    keywords: [
      'dog food', 'food for dog', 'meal', 'meals',
      'nutrition', 'diet', 'grain free food', 'puppy food',
      'dry food', 'wet food', 'premium food'
    ],
    collection: 'dog-food'
  },

  /*
    Dog bundles
  */
  {
    keywords: [
      'dog bundle', 'dog bundles', 'dog gift bundle',
      'bundle for dog', 'bundle for dogs', 'dog set',
      'dog pack', 'dog packs'
    ],
    collection: 'dog-bundles'
  },

  /*
    Cat bundles
  */
  {
    keywords: [
      'cat bundle', 'cat bundles', 'cat gift bundle',
      'bundle for cat', 'bundle for cats', 'cat set',
      'cat pack', 'cat packs', 'cat lover gift'
    ],
    collection: 'cat-bundles'
  },

  /*
    Monthly specials / deals
  */
  {
    keywords: [
      'special', 'specials', 'monthly special', 'monthly specials',
      'offer', 'offers', 'deal', 'deals', 'discount', 'sale',
      'clearance', 'bundle deal'
    ],
    collection: 'monthly-special'
  }
];

var FALLBACK_COLLECTION = 'pet-hampers';

  function safeJsonParse(value, fallback) {
    if (!value) return fallback;
    try {
      var parsed = JSON.parse(value);
      return parsed || fallback;
    } catch (e) {
      return fallback;
    }
  }

  function getBehavior() {
    var data = safeJsonParse(localStorage.getItem(STORAGE_KEY), {}) || {};
    return {
      productViews: Array.isArray(data.productViews) ? data.productViews : Array.isArray(data.products) ? data.products : [],
      collectionViews: Array.isArray(data.collectionViews) ? data.collectionViews : Array.isArray(data.collections) ? data.collections : [],
      searches: Array.isArray(data.searches) ? data.searches : [],
      addedToCart: Array.isArray(data.addedToCart) ? data.addedToCart : [],
      upsellClicks: Array.isArray(data.upsellClicks) ? data.upsellClicks : [],
      lastUpdated: data.lastUpdated || null
    };
  }

  function saveBehavior(data) {
    data.lastUpdated = new Date().toISOString();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  function pushUnique(list, item, keyName, max) {
    if (!Array.isArray(list)) list = [];
    if (!item || !item[keyName]) return list;

    var filtered = list.filter(function (oldItem) {
      return oldItem && oldItem[keyName] !== item[keyName];
    });

    filtered.unshift(item);
    return filtered.slice(0, max || 20);
  }

  function trackCurrentPage() {
    var ctx = window.AB_UPSELL_PAGE_CONTEXT || {};
    var behavior = getBehavior();

    if (ctx.pageType === 'product' && ctx.product && ctx.product.handle) {
      behavior.productViews = pushUnique(behavior.productViews, {
        id: ctx.product.id,
        handle: ctx.product.handle,
        title: ctx.product.title,
        url: ctx.product.url,
        collections: ctx.product.collections || [],
        time: Date.now()
      }, 'handle', 20);
    }

    if (ctx.pageType === 'collection' && ctx.collection && ctx.collection.handle) {
      behavior.collectionViews = pushUnique(behavior.collectionViews, {
        handle: ctx.collection.handle,
        title: ctx.collection.title,
        url: ctx.collection.url,
        time: Date.now()
      }, 'handle', 20);
    }

    if (ctx.pageType === 'search' && ctx.searchTerm) {
      behavior.searches = pushUnique(behavior.searches, {
        term: String(ctx.searchTerm).toLowerCase(),
        time: Date.now()
      }, 'term', 20);
    }

    saveBehavior(behavior);
  }

  function trackAddedToCartFromButton(button) {
    var behavior = getBehavior();

    behavior.addedToCart = pushUnique(behavior.addedToCart, {
      variantId: button.getAttribute('data-variant-id') || '',
      handle: button.getAttribute('data-product-handle') || '',
      title: button.getAttribute('data-product-title') || '',
      page: window.location.pathname,
      time: Date.now()
    }, 'variantId', 20);

    saveBehavior(behavior);
  }

  function behaviorText(behavior) {
    var parts = [];

    behavior.collectionViews.forEach(function (item) {
      parts.push(item.handle || '', item.title || '');
    });

    behavior.productViews.forEach(function (item) {
      parts.push(item.handle || '', item.title || '');
      if (Array.isArray(item.collections)) parts = parts.concat(item.collections);
    });

    behavior.searches.forEach(function (item) {
      parts.push(item.term || '');
    });

    behavior.addedToCart.forEach(function (item) {
      parts.push(item.handle || '', item.title || '', item.page || '');
    });

    return parts.join(' ').toLowerCase();
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getCollectionIndex() {
    var rawCollections = Array.isArray(window.AB_COLLECTION_INDEX) ? window.AB_COLLECTION_INDEX : [];
    var ignoredWords = [
      'and', 'the', 'for', 'with', 'from',
      'gift', 'gifts', 'hamper', 'hampers',
      'basket', 'baskets', 'collection', 'collections',
      'product', 'products', 'shop', 'all',
      'new', 'best', 'selling', 'sale'
    ];

    return rawCollections
      .filter(function (collection) {
        return collection && collection.handle;
      })
      .map(function (collection) {
        var baseText = normalizeText((collection.handle || '') + ' ' + (collection.title || ''));

        var keywords = baseText.split(' ').filter(function (word) {
          return word.length > 2 && ignoredWords.indexOf(word) === -1;
        });

        keywords = keywords.filter(function (word, index) {
          return keywords.indexOf(word) === index;
        });

        return {
          handle: collection.handle,
          title: collection.title || collection.handle,
          url: collection.url || '/collections/' + collection.handle,
          keywords: keywords
        };
      });
  }

  function matchPriorityCollectionFromText(text) {
    text = normalizeText(text);

    for (var i = 0; i < PRIORITY_KEYWORD_RULES.length; i++) {
      var rule = PRIORITY_KEYWORD_RULES[i];

      for (var j = 0; j < rule.keywords.length; j++) {
        var keyword = normalizeText(rule.keywords[j]);

        if (keyword && text.indexOf(keyword) !== -1) {
          return rule.collection;
        }
      }
    }

    return null;
  }

  function matchDynamicCollectionFromText(text) {
    text = normalizeText(text);
    if (!text) return null;

    var collections = getCollectionIndex();
    if (!collections.length) return null;

    var bestMatch = null;
    var bestScore = 0;

    collections.forEach(function (collection) {
      var score = 0;
      var handleText = normalizeText(collection.handle);
      var titleText = normalizeText(collection.title);
      var textWords = text.split(' ');

      if (handleText && text.indexOf(handleText) !== -1) score += 10;
      if (titleText && text.indexOf(titleText) !== -1) score += 10;

      collection.keywords.forEach(function (keyword) {
        if (keyword && text.indexOf(keyword) !== -1) score += 2;
        if (keyword && textWords.indexOf(keyword) !== -1) score += 3;
      });

      if (score > bestScore) {
        bestScore = score;
        bestMatch = collection.handle;
      }
    });

    return bestScore > 0 ? bestMatch : null;
  }

  function matchCollectionFromText(text) {
    var priorityMatch = matchPriorityCollectionFromText(text);
    if (priorityMatch) return priorityMatch;

    return matchDynamicCollectionFromText(text);
  }

  function chooseUpsellCollection(cart) {
    var behavior = getBehavior();
    var ctx = window.AB_UPSELL_PAGE_CONTEXT || {};

    if (behavior.addedToCart && behavior.addedToCart.length) {
      var lastAdded = behavior.addedToCart[0];

      var lastAddedText = [
        lastAdded.handle || '',
        lastAdded.title || '',
        lastAdded.page || '',
        lastAdded.url || ''
      ].join(' ');

      var lastAddedMatch = matchCollectionFromText(lastAddedText);
      if (lastAddedMatch) return lastAddedMatch;
    }

    if (cart && Array.isArray(cart.items) && cart.items.length) {
      var cartText = cart.items.map(function (item) {
        return [
          item.title || '',
          item.product_title || '',
          item.url || '',
          item.handle || '',
          item.vendor || '',
          item.product_type || ''
        ].join(' ');
      }).join(' ');

      var cartMatch = matchCollectionFromText(cartText);
      if (cartMatch) return cartMatch;
    }

    var currentPageText = '';

    if (ctx.collection) {
      currentPageText += ' ' + (ctx.collection.handle || '') + ' ' + (ctx.collection.title || '');
    }

    if (ctx.product) {
      currentPageText += ' ' + (ctx.product.handle || '') + ' ' + (ctx.product.title || '');

      if (Array.isArray(ctx.product.collections)) {
        currentPageText += ' ' + ctx.product.collections.join(' ');
      }
    }

    if (ctx.searchTerm) {
      currentPageText += ' ' + ctx.searchTerm;
    }

    var pageMatch = matchCollectionFromText(currentPageText);
    if (pageMatch) return pageMatch;

    var behaviorMatch = matchCollectionFromText(behaviorText(behavior));
    if (behaviorMatch) return behaviorMatch;

    return FALLBACK_COLLECTION;
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD'
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function productImage(product) {
    if (product.featured_image) return product.featured_image;

    if (product.images && product.images.length) {
      if (typeof product.images[0] === 'string') return product.images[0];
      if (product.images[0].src) return product.images[0].src;
    }

    return '';
  }

  function firstAvailableVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;

    var available = product.variants.find(function (variant) {
      return variant.available !== false;
    });

    return available || product.variants[0];
  }

  function normalizePrice(product, variant) {
    if (variant && variant.price) {
      var price = variant.price;

      if (typeof price === 'string' && price.indexOf('.') !== -1) {
        return Math.round(parseFloat(price) * 100);
      }

      return Number(price);
    }

    if (product.price) return Number(product.price);

    return 0;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json();
    });
  }

  function fetchCollectionProducts(handle) {
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=30', {
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Collection not found: ' + handle);
        return res.json();
      })
      .then(function (data) {
        return data.products || [];
      });
  }

  function filterProducts(products, cart) {
    var cartProductIds = (cart.items || []).map(function (item) {
      return Number(item.product_id);
    });

    return products.filter(function (product) {
      var variant = firstAvailableVariant(product);

      if (!variant) return false;
      if (cartProductIds.indexOf(Number(product.id)) !== -1) return false;

      return true;
    }).slice(0, MAX_ITEMS_TO_SHOW);
  }

  function renderUpsells(products) {
    var wrapper = document.getElementById('ABBehaviorUpsell');
    if (!wrapper) return;

    var itemsWrap = wrapper.querySelector('[data-ab-upsell-items]');
    if (!itemsWrap) return;

    if (!products.length) {
      wrapper.hidden = true;
      itemsWrap.innerHTML = '';
      return;
    }

    itemsWrap.innerHTML = [
      '<div class="ab-upsell-carousel" data-ab-carousel>',
        '<button class="ab-upsell-nav ab-upsell-prev" type="button" data-ab-prev aria-label="Previous product">&#8249;</button>',
        '<div class="ab-upsell-viewport">',
          '<div class="ab-upsell-track" data-ab-track>',
            products.map(function (product) {
              var variant = firstAvailableVariant(product);
              if (!variant) return '';

              var image = productImage(product);
              var price = normalizePrice(product, variant);
              var title = escapeHtml(product.title || '');
              var handle = escapeHtml(product.handle || '');

              return [
                '<div class="ab-upsell-slide">',
                  '<div class="ab-upsell-item" data-ab-upsell-product>',
                    '<button class="ab-upsell-image-link" type="button" data-variant-id="' + variant.id + '" data-product-handle="' + handle + '" data-product-title="' + title + '" aria-label="Add ' + title + ' to cart">',
                      image ? '<img class="ab-upsell-image" src="' + image + '" alt="' + title + '" loading="lazy">' : '',
                    '</button>',
                    '<div class="ab-upsell-info">',
                      '<button class="ab-upsell-title" type="button" data-variant-id="' + variant.id + '" data-product-handle="' + handle + '" data-product-title="' + title + '" aria-label="Add ' + title + ' to cart">' + title + '</button>',
                      '<div class="ab-upsell-price">' + formatMoney(price) + '</div>',
                    '</div>',
                    '<button class="ab-upsell-add" type="button" data-variant-id="' + variant.id + '" data-product-handle="' + handle + '" data-product-title="' + title + '" aria-label="Add ' + title + ' to cart">Add</button>',
                  '</div>',
                '</div>'
              ].join('');
            }).join(''),
          '</div>',
        '</div>',
        '<button class="ab-upsell-nav ab-upsell-next" type="button" data-ab-next aria-label="Next product">&#8250;</button>',
        '<div class="ab-upsell-dots">',
          products.map(function (_, index) {
            return '<button class="ab-upsell-dot' + (index === 0 ? ' is-active' : '') + '" type="button" data-ab-dot data-index="' + index + '" aria-label="Go to slide ' + (index + 1) + '"></button>';
          }).join(''),
        '</div>',
      '</div>'
    ].join('');

    wrapper.hidden = false;
    initUpsellCarousel(wrapper);
  }

  function initUpsellCarousel(wrapper) {
    var carousel = wrapper.querySelector('[data-ab-carousel]');
    if (!carousel) return;

    var track = carousel.querySelector('[data-ab-track]');
    var slides = carousel.querySelectorAll('.ab-upsell-slide');
    var prevBtn = carousel.querySelector('[data-ab-prev]');
    var nextBtn = carousel.querySelector('[data-ab-next]');
    var dots = carousel.querySelectorAll('[data-ab-dot]');

    if (!track || !slides.length) return;

    var currentIndex = 0;
    var total = slides.length;

    function updateCarousel() {
      track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';

      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === total - 1;

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === currentIndex);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (currentIndex > 0) {
          currentIndex--;
          updateCarousel();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (currentIndex < total - 1) {
          currentIndex++;
          updateCarousel();
        }
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        currentIndex = Number(dot.getAttribute('data-index')) || 0;
        updateCarousel();
      });
    });

    updateCarousel();
  }

  function syncCartCount(cart) {
    var selectors = [
      '.hdt-cart-count',
      '.t4s-cart-count',
      '.t4s-pr-count',
      '[data-cart-count]',
      '[data-cart-count-bubble]',
      '.cart-count',
      '.site-header__cart-count'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = cart.item_count;
      });
    });

    var drawer = document.getElementById('t4s-mini_cart');

    if (drawer) {
      drawer.setAttribute('data-ccount', cart.item_count);
    }
  }

  function refreshCartDrawerUI() {
    return Promise.all([
      fetch('/cart.js', {
        credentials: 'same-origin'
      }).then(function (res) {
        return res.json();
      }),

      fetch(window.location.pathname + '?section_id=mini_cart', {
        credentials: 'same-origin'
      }).then(function (res) {
        return res.text();
      })
    ])
      .then(function (results) {
        var cart = results[0];
        var html = results[1];

        syncCartCount(cart);

        var temp = document.createElement('div');
        temp.innerHTML = html;

        var currentDrawer = document.getElementById('t4s-mini_cart');
        var newDrawer = temp.querySelector('#t4s-mini_cart');

        if (currentDrawer && newDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        } else {
          var currentItems = document.querySelector('#t4s-mini_cart [data-cart-items]');
          var newItems = temp.querySelector('[data-cart-items]');

          var currentBottom = document.querySelector('#t4s-mini_cart .t4s-drawer__bottom');
          var newBottom = temp.querySelector('.t4s-drawer__bottom');

          if (currentItems && newItems) {
            currentItems.innerHTML = newItems.innerHTML;
          }

          if (currentBottom && newBottom) {
            currentBottom.innerHTML = newBottom.innerHTML;
          }
        }

        setTimeout(loadUpsells, 250);
      })
      .catch(function (error) {
        console.warn('[AB Upsell] Mini cart refresh failed:', error);
        loadUpsells();
      });
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function loadUpsells() {
    fetchCart()
      .then(function (cart) {
        var collectionHandle = chooseUpsellCollection(cart);

        return fetchCollectionProducts(collectionHandle).then(function (products) {
          var filteredProducts = filterProducts(products, cart);
          renderUpsells(filteredProducts);
        });
      })
      .catch(function (error) {
        console.warn('[AB Upsell] Failed:', error);
      });
  }

  function addVariantToCart(variantId, button) {
    if (!variantId || !button) return;

    button.disabled = true;

    var oldText = button.textContent;
    var isAddButton = button.classList.contains('ab-upsell-add');

    if (isAddButton) {
      button.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        trackAddedToCartFromButton(button);

        if (isAddButton) {
          button.textContent = 'Added';
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('t4s:cart:refresh'));

        return refreshCartDrawerUI();
      })
      .then(function () {
        setTimeout(loadUpsells, 250);
      })
      .catch(function (error) {
        console.warn('[AB Upsell] Add failed:', error);

        button.disabled = false;

        if (isAddButton) {
          button.textContent = oldText;
        }
      });
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var addTarget = event.target.closest('.ab-upsell-add, .ab-upsell-title, .ab-upsell-image-link');

      if (!addTarget) return;

      event.preventDefault();

      var variantId = addTarget.getAttribute('data-variant-id');

      if (!variantId) return;

      addVariantToCart(variantId, addTarget);
    });

    document.addEventListener('click', function (event) {
      var cartTrigger = event.target.closest(
        '[data-drawer-delay], [data-drawer-options], [data-drawer-open], [data-cart-trigger], [href="/cart"], .t4s-site-nav__cart, .t4s-cart-count, .t4s-pr-count, .t4s-icon-cart'
      );

      if (cartTrigger) {
        setTimeout(loadUpsells, 500);
      }
    });

    var drawer = document.getElementById('t4s-mini_cart');

    if (drawer && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        var isOpen =
          drawer.getAttribute('aria-hidden') === 'false' ||
          drawer.classList.contains('is--opened') ||
          drawer.classList.contains('is-open') ||
          drawer.classList.contains('t4s-drawer-open');

        if (isOpen) {
          setTimeout(loadUpsells, 250);
        }
      });

      observer.observe(drawer, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'class']
      });
    }

    setTimeout(loadUpsells, 800);
  }

  function exposeDebug() {
    window.ABUpsellDebug = {
      behavior: getBehavior,

      clear: function () {
        localStorage.removeItem(STORAGE_KEY);
        console.log('AB upsell behavior cleared');
      },

      collection: function () {
        return chooseUpsellCollection();
      },

      collectionWithCart: function () {
        return fetchCart().then(function (cart) {
          return chooseUpsellCollection(cart);
        });
      },

      reload: loadUpsells,

      collections: function () {
        return getCollectionIndex();
      },

      keywords: function () {
        return getCollectionIndex().map(function (collection) {
          return {
            handle: collection.handle,
            title: collection.title,
            keywords: collection.keywords
          };
        });
      },

      reason: function () {
        return fetchCart().then(function (cart) {
          return {
            selectedCollection: chooseUpsellCollection(cart),
            cart: cart.items.map(function (item) {
              return {
                title: item.product_title || item.title,
                url: item.url,
                product_type: item.product_type,
                vendor: item.vendor
              };
            }),
            behavior: getBehavior(),
            currentPage: window.AB_UPSELL_PAGE_CONTEXT || {},
            loadedCollections: getCollectionIndex()
          };
        });
      }
    };
  }

  function init() {
    exposeDebug();
    trackCurrentPage();
    bindEvents();

    setTimeout(loadUpsells, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();